import {WIDGET_SLIDEOUT_WIDTH} from "./styles"

const SLIDEOUT_BODY_CLASS = "ri2-slideout-active"
const SLIDEOUT_WIDTH_VAR = "--ri2-slideout-width"
const MOBILE_BREAKPOINT = 768

export const applySlideoutLayout = (): void => {
  if (window.ri2?.displayMode !== "slideout") return
  if (window.innerWidth < MOBILE_BREAKPOINT) return
  document.body.classList.add(SLIDEOUT_BODY_CLASS)
  document.documentElement.style.setProperty(
    SLIDEOUT_WIDTH_VAR,
    `${WIDGET_SLIDEOUT_WIDTH}px`,
  )
}

export const removeSlideoutLayout = (): void => {
  document.body.classList.remove(SLIDEOUT_BODY_CLASS)
  document.documentElement.style.removeProperty(SLIDEOUT_WIDTH_VAR)
}
